import { ApolloLink } from 'apollo-link';

export const AttachExtensionsLink = new ApolloLink((operation, forward) => {
	if (operation.variables && operation.variables.__extensions) {
		operation.setContext({ extensions: operation.variables.__extensions });
		// remove the property since it's not an actual valid variable
		delete operation.variables.__extensions;
	}
	return forward(operation);
});
